import { ReactSVG } from "react-svg";
import { MenuItemType } from "../../../../types/baseTypes";
import styles from "./SubMenu.module.scss";
import { useGlobalContext } from "@aleksundshantu.com/aunds-utils-react/contexts";
import MenuItem from "../MenuItem/MenuItem";
import { MenuParentType } from "../Menu";
import { isMenuOrChildMenuSelected } from "../utils";
import { FocusTrap } from "@aleksundshantu.com/aunds-utils-react/accessibility";
import React from "react";
import { useKeyboardNavigation } from "../keyboard-navigation";
import { Post } from "@/wp/types/client";

interface SubMenuItemProps {
  item: MenuItemType;
  pageData: Post;
  currentSubmenu: MenuParentType;
  parentSubMenu: MenuParentType;
  subMenu: MenuParentType;
  parentMenuItem: MenuItemType;
  setCurrentSubmenu: (value: MenuParentType) => void;
  controlParentMenu: (action: "close" | "prev" | "next") => void;
}

const SubMenu = ({
  item,
  pageData,
  currentSubmenu,
  setCurrentSubmenu,
  parentSubMenu,
  subMenu,
  parentMenuItem,
  controlParentMenu,
}: SubMenuItemProps) => {
  const { getIcon, getLabel } = useGlobalContext();

  const { items, keyDown, controlMenu, firstItemFocused } =
    useKeyboardNavigation({
      menu: item,
      setCurrentSubmenu,
      type: "submenu",
      controlParentMenu,
      subMenu,
    });

  return (
    <FocusTrap dep={currentSubmenu} disabled={currentSubmenu?.ID !== item.ID}>
      <ul
        className={`${styles["navbar-submenu"]} navbar-submenu ${currentSubmenu?.ID !== item.ID ? "trap enabled" : "trap disabled"} ${isMenuOrChildMenuSelected(item, currentSubmenu) ? styles["is-open"] : ""}`}
        role="menu"
        onKeyDown={keyDown}
      >
        <li
          className={`${styles["navbar-submenu-title"]} navbar-link is-hidden-after-navbar-breakpoint`}
        >
          {parentMenuItem.title}
        </li>

        {Array.isArray(item.child_items) &&
          item.child_items.map((child, key) => {
            if (!items.current[key]) {
              items.current[key] = React.createRef<HTMLLIElement>();
            }

            return (
              <MenuItem
                item={child}
                key={key}
                pageData={pageData}
                currentSubmenu={currentSubmenu}
                setCurrentSubmenu={setCurrentSubmenu}
                parentSubMenu={item}
                subMenu={item}
                tabIndex={-1}
                itemRef={items.current[key]}
                controlParentMenu={controlMenu}
                onFocus={key == 0 ? firstItemFocused : undefined}
              />
            );
          })}

        <li className="is-hidden-after-navbar-breakpoint" role="none">
          <button
            className="back button-reset is-flex is-align-items-center is-gap-2 navbar-sublink"
            role="menuitem"
            onClick={() => {
              setCurrentSubmenu(parentSubMenu);
            }}
          >
            <ReactSVG
              width={16}
              height={16}
              src={getIcon("arrowLeft")}
              wrapper={"svg"}
              aria-hidden
              beforeInjection={(svg) => {
                svg.setAttribute("alt", `Arrow left Icon`);
                svg.setAttribute("aria-label", `Arrow left Icon`);
                svg.setAttribute("aria-hidden", `true`);
              }}
            />
            <span>{getLabel("back")}</span>
          </button>
        </li>
      </ul>
    </FocusTrap>
  );
};

export default SubMenu;
